'use client';

import { cn } from 'cn';
import { type PropsWithChildren } from 'react';

type P = PropsWithChildren<{
  readonly contentClassName?: string;
  readonly show: boolean;
}> &
  ComponentStyling;

/**
 * Reveal the children by animating from zero to full height when `show` is true.
 * Uses a CSS technique called grid reveal.
 */
export const Reveal = ({
  children,
  className = '',
  contentClassName,
  show,
  style,
}: P) => (
  <div
    className={cn(
      'grid',
      {
        'grid-rows-[0fr] duration-200 ease-in': !show,
        'grid-rows-[1fr] duration-300 ease-out': show,
      },
      className,
    )}
    style={{
      transitionProperty: 'grid-template-rows',
      ...style,
    }}
  >
    <div className={cn('overflow-hidden', contentClassName)}>{children}</div>
  </div>
);
